import { gql, useQuery } from '@apollo/client';
import { buildQuery } from '../usePageQuery';
import { usePageMeta } from '../usePageMeta';
import {
  PageType,
  SupportsGiftAidPageDataQuery,
} from '../../../types/__generated__';
import { captureException } from '@sentry/browser';
import { useEffect } from 'react';

const QUERY = gql`
  query SupportsGiftAidPageData(
    $type: PageType!
    $slug: Slug
    $id: ID
    $preview: Preview
  ) {
    page(type: $type, slug: $slug, preview: $preview, id: $id) {
      id
      supportsGiftAid
    }
  }
`;

export function useSupportsGiftAid() {
  let { pageType, pageSlug, isPreview, pageGuid } = usePageMeta();

  if (pageType.toUpperCase() === PageType.Fundraising) {
    pageType = PageType.OnePage;
    pageSlug = `${PageType.Fundraising}/${pageSlug}`;
  }

  const result = useQuery<SupportsGiftAidPageDataQuery>(QUERY, {
    variables: {
      type: pageType.toUpperCase(),
      slug: pageSlug,
      id: pageGuid,
      preview: isPreview,
    },
    ssr: true,
  });

  useEffect(() => {
    if (result.error) {
      captureException(result.error);
    }
  }, [result.error]);

  return result;
}
